import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IXmlDemandRequest } from '../models/models'

export class InsertXmlDemandApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/insertXmlDemand',
      requesterInfo,
    })
  }

  public async insertXmlDemand(request: IXmlDemandRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
